/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 29/3/2023
 */

import { createSlice } from '@reduxjs/toolkit';

export const resourceSlice = createSlice({
  name: "resource",
  initialState: {
    modalStatus: false,
    selectedResource: null
  },
  reducers: {
    openAddResourceModal: (state) => {
      state.modalStatus = "add";
    },
    openEditResourceModal: (state, action) => {
      state.modalStatus = "edit";
      state.selectedResource = action.payload;
    },
    openDeleteResourceModal: (state, action) => {
      state.modalStatus = "delete";
      state.selectedResource = action.payload;
    },
    closeResourceModal: (state) => {
      state.modalStatus = false;
      state.selectedResource = null;
    },
    openAvailabilityResourceModal: (state, action) => {
      state.modalStatus = "availability";
      state.selectedResource = action.payload;
    },
  }
});

export const {
  openAddResourceModal,
  openEditResourceModal,
  openDeleteResourceModal,
  closeResourceModal,
  openAvailabilityResourceModal
} = resourceSlice.actions;

export default resourceSlice.reducer;